import { useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { StandardPanel } from '../../../_components/panel/standard.panel';
import { TicketQueryList } from './ticket-queryList';
import { TicketQueryDrawer } from "./ticket-queryDrawer";

export function TicketQueryPanel() {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [refreshCounter, setRefreshCounter] = useState(0);

    return (
        <>
            <StandardPanel
                title="Comment / Query"
                buttons={[
                    { icon: "add", onClick: () => { navigate("ManageQueries/Create") } }
                ]}
                loading={isLoading}>

                <TicketQueryList refreshCounter={refreshCounter} />
            </StandardPanel>
            <Routes>
                <Route path="ManageQueries/*" element={<TicketQueryDrawer onSave={() => { setRefreshCounter(r => (++r)); navigate(""); }} onClose={() => { navigate(""); }} />} />
            </Routes>

        </>
    );

}
